import React from 'react'
import {Box, Flex, Image, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {ChevronRight} from '../../../components/icons'

const ProductRegistrationCategoryImageContainer = ({image, title, id, handleCategoryClick}) => {
    return (
        <Flex
            as="button"
            onClick={() => handleCategoryClick({id})}
            alignItems="center"
            gap="16px"
            paddingX="24px"
            paddingY="8px"
            borderRadius="8px"
            border="1px solid"
            borderColor="border.dark"
            cursor="pointer"
            _hover={{borderColor: 'border.dark'}}
            alignSelf="stretch"
        >
            {image ? (
                <Image
                    src={image}
                    alt={title}
                    w="48px"
                    h="48px"
                    flexShrink={0}
                    objectFit="contain"
                />
            ) : (
                <Box w="48px" h="48px" flexShrink={0} bg="transparent" aria-hidden="true" />
            )}
            <Text
                textStyle="body-small"
                fontWeight="medium"
                color="text.default"
                flex="1"
                textAlign="left"
            >
                {title}
            </Text>
            <ChevronRight aria-label="right icon" width="24px" height="24px" />
        </Flex>
    )
}

ProductRegistrationCategoryImageContainer.propTypes = {
    image: PropTypes.string,
    title: PropTypes.node,
    id: PropTypes.string,
    handleCategoryClick: PropTypes.func,
    variant: PropTypes.string,
}

export default ProductRegistrationCategoryImageContainer
